import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import Helmet from 'react-helmet';
import AuthCard from '../../Shared/AuthCard';
import TextInput from '../../Shared/TextInput';
import FlashMessages from '../../Shared/FlashMessages';
import Logo from '../../Shared/Logo';

function VerifyEmailMessage() {
     const { errors, app, caption } = usePage().props;
     return (
          <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0">
               <Helmet>
                    <title>{`${app.name} | Please Verify Email`}</title>
               </Helmet>
               <img src={app.mhd.logo_simple} className="w-20" />
               <AuthCard>
                    <FlashMessages />
                    <p className="text-center text-md font-base text-gray-600">{caption.verify_email}</p>
                    <div className="w-full justify-center items-center">
                         <InertiaLink href={route('verification.send')} as="button" method="post" className="mt-4 inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                              {caption.resend_conf}
                         </InertiaLink>
                    </div>
               </AuthCard>
          </div>
     );
}

export default VerifyEmailMessage;
